import type { UiMessages } from "../types";

export const ja: UiMessages = {
  nav: {
    streams: "ライブ配信",
    videos: "エロ動画",
    shorts: "ショート",
    forYou: "おすすめ",
    vr: "VR",
    cartoon: "カートゥーン",
    hentai: "エロアニメ",
    sections: "その他",
    menu: "メニュー",
    game: "エロゲーム",
    stories: "官能小説",
    escorts: "エスコート",
    ai: "AI彼女",
    paysites: "プレミアムサイト",
    home: "ホーム",
    following: "フォロー中",
    watching: "視聴履歴",
    rankings: "ランキング",
    invite: "友だちを招待",
    coins: "Sweet Coin",
    achievements: "実績",
    hot: "今アツい",
    random: "ランダム動画",
    saved: "保存済み",
    reacted: "リアクションした動画",
    boost: "Sweet Boost",
    premium: "プレミアム",
    stars: "ポルノスター",
    productions: "スタジオ",
    categories: "カテゴリー",
    telegram: "Telegramチャンネル",
    allSections: "すべてのセクション",
    mainNavigation: "メインメニュー",
    quickNavigation: "クイックメニュー",
    show: "表示",
    coinsReady: "Sweet Coinを受け取れます",
    logIn: "ログイン",
    search: "検索",
    closeSearch: "検索を閉じる",
    language: "言語",
    theme: "テーマ",
    themeDark: "ダーク",
    themeLight: "ライト",
  },
  age: {
    parents: "保護者の方へ：{link}のページで、このサイトへのアクセスをブロックする方法をご案内しています。SweetにはRTAラベルが付いています。",
    parentalControls: "ペアレンタルコントロール",
    title: "このサイトはアダルトサイトです",
    body: "このサイトには、ヌードや露骨な性行為の描写を含む年齢制限付きのコンテンツが含まれています。入場すると、あなたが18歳以上（またはアクセスしている国・地域の成年年齢以上）であること、そして性的に露骨なコンテンツの閲覧に同意することを確認したものとみなされます。",
    enter: "18歳以上です — 入場する",
    exit: "18歳未満です — 退場する",
  },
  consent: {
    title: "Cookie",
    body: "Sweetは広告のおかげで無料でご利用いただけます。広告パートナーは、広告の表示と、その表示回数やクリック数の計測にCookieを使用します。年齢確認など必要なデータは、どちらを選んでも保存されます。",
    privacy: "プライバシーポリシー",
    acceptAll: "すべて許可",
    onlyNecessary: "必須のみ",
    settings: "Cookie設定",
  },
  ago: { now: "たった今", m: "{n}分前", h: "{n}時間前", d: "{n}日前", w: "{n}週間前", mo: "{n}か月前", y: "{n}年前" },
  cams: {
    allPlatforms: "すべてのサイト",
    watchOnSite: "{site}で見る",
    liveFor: "配信中・{time}",
    tryAnother: "別のタグや地域を選ぶか、しばらくしてからもう一度チェックしてください。",
    nobodyLiveOn: "現在{name}で配信中のモデルはいません",
    platformShowUpHint: "{name}の配信は、始まるとすぐにここに表示されます。しばらくしてからもう一度チェックしてください。",
    liveNowCount: "現在{n}人が配信中",
    opensOn: "{site}で開きます",
    streamerSite: "配信元のサイト",
    orWatch: "または{link}をご覧ください。",
    videoTag: "#{tag}の動画",
    liveStreams: "ライブ配信",
    platformStreams: "{name}のライブ配信",
    liveCams: "ライブチャット",
    platformCams: "{name}のライブチャット",
    moreLiveCams: "その他のライブチャット",
    byTopic: "ジャンル別ライブチャット",
    breadcrumb: "パンくずリスト",
    live: "配信中",
    viewers: "視聴者数：",
    isLive: "{name}が配信中",
    watchOn: "{title} — {site}でライブ視聴",
    nobodyLive: "現在配信中のモデルはいません",
    noMatch: "この条件に一致するライブ配信はありません",
    showUpHint: "配信は始まるとすぐにここに表示されます。しばらくしてからもう一度チェックしてください。",
    clearFilters: "条件をクリア",
    clearAll: "すべてクリア",
    clear: "クリア",
    seeAllPlatforms: "すべてのサイトを見る",
    watchVideos: "エロ動画を見る",
    onPlatform: "（{name}）",
    newOnTelegram: "Telegramで新着ライブチャット",
    loadMoreFailed: "読み込めませんでした — もう一度お試しください",
    platforms: "サイト",
    streamPlatforms: "配信サイト",
    platformsAndFilters: "配信サイトと絞り込み",
    categories: "カテゴリー",
    all: "すべて",
    region: "地域",
    allRegions: "すべての地域",
    more: "その他",
    newModels: "新人モデル",
    tags: "タグ",
    removeTag: "タグを外す",
    remove: "外す",
    loading: "読み込み中",
    offline: "オフライン",
    seeAll: "すべて見る",
    genders: { female: "女性", male: "男性", couple: "カップル", trans: "トランス" },
    regions: { north_america: "北米", south_america: "南米", europe: "ヨーロッパ・ロシア", asia: "アジア", other: "その他の地域" },
  },
  video: {
    fullScene: "{site}で本編を見る",
    upNext: "次の動画",
    nextPage: "次のページ",
    moreVideos: "その他の動画",
    end: "これ以上はありません。",
    loadMoreFailed: "読み込めませんでした — もう一度お試しください",
    likes: "いいね",
    premiumVideo: "プレミアム動画",
    subscribeToWatch: "この動画をフルで見るには、プレミアムに登録してください。",
    getPremium: "プレミアムに登録",
    logIn: "ログイン",
    playsIn: "{name}のプレーヤーで再生",
    partnerBlocked: "動画は{name}のサーバーから再生されますが、お使いのネットワークからは接続できません。プロバイダーやお住まいの国で{name}がブロックされている可能性があります。",
    unavailable: "{name}はお住まいの国で動画を配信していないため、この動画はここでは視聴できません。",
    watchCams: "代わりにライブチャットを見る",
    chatLive: "{site}で{name}とライブチャット",
    play: "{title}を再生",
    sponsored: "広告",
    onlyfansCreators: "OnlyFansクリエイター",
    liveNowFree: "配信中 · 無料",
    allVideos: "すべての動画",
    stoppedAt: "{at}まで視聴（全{of}）",
    watchedToEnd: "最後まで視聴済み",
  },
  profile: { followers: "フォロワー", views: "再生回数", videos: "動画", verified: "認証済み", follow: "フォロー", unfollow: "フォロー解除" },
  lists: {
    categories: "カテゴリー",
    popular: "人気",
    aToZ: "名前順",
    jumpToLetter: "頭文字へジャンプ",
    allCategories: "すべてのカテゴリー",
    noVideosYet: "まだ動画がありません",
    pageN: "{n}ページ目",
    newEveryDay: "新着動画を毎日追加中。",
    videoCount: "{n}本の動画",
    pornstars: "ポルノスター",
    pornstarsIntro: "今週もっともフォローされている人気ポルノスター。",
    studios: "ポルノスタジオ",
    studiosIntro: "制作会社やチャンネルをフォロワー数順に掲載。",
    noVideosWithTag: "このタグの動画はありません",
    showAllVideos: "すべての動画を表示",
  },
  hot: {
    title: "今アツい",
    intro: "ここ数時間でSweetで最も見られている動画。",
  },
  comments: {
    title: "コメント",
    placeholder: "コメントを追加…",
    post: "投稿",
    login: "ログインしてコメント",
    coinsHint: "1日の最初の{max}件のコメントごとに+{n}コイン",
    earned: "+{n}コイン",
    empty: "まだコメントはありません。最初のコメントをどうぞ。",
    more: "もっと見る",
    delete: "削除",
    short: "もう少し書いてください。",
    long: "長すぎます：最大{n}文字です。",
    links: "コメントにリンクや連絡先は書けません。",
    forbidden: "このコメントは投稿できません。",
    rate: "コメントのペースが速すぎます。しばらくしてからお試しください。",
    duplicate: "同じ内容はすでに投稿済みです。",
    failed: "投稿できませんでした。もう一度お試しください。",
    like: "高評価",
    dislike: "低評価",
    rateLogin: "ログインして動画を評価",
    liked: "{p}%が高評価",
  },
  starVote: {
    title: "今月のスター",
    vote: "投票する",
    voteFor: "{name}を今月のスターに投票",
    voteAgain: "もう一度投票 · {n}コイン",
    confirm: "{n}コインを使いますか？",
    standing: "今月{rank}位 · 票数: {n}",
    noVotes: "今月はまだ投票がありません",
    thanks: "投票ありがとうございます！",
    paidThanks: "投票しました · −{n}コイン",
    coins: "コインが足りません：1票{n}コインです。",
    limit: "今日の投票はここまでです。",
    rules: "1日1回は無料、その後は1票{n}コイン。",
    boardIntro: "メンバーはスターのページでお気に入りに投票できます。1日1回は無料、追加は1票{n}コイン。",
    boardEmpty: "今月はまだ投票がありません。スターのページで投票しましょう。",
    votes: "票数",
    lastWinner: "先月のスター",
    login: "ログインして投票",
  },
  achievements: {
    title: "実績",
    intro: "視聴・フォロー・参加で実績を解除しましょう。解除するたびにSweet Coinがもらえます。",
    unlocked: "解除済み",
    coins: "+{n}コイン",
    progress: "{x} / {n}",
    total: "{n}個中{x}個を解除",
    login: "ログインして実績とコインを集めましょう。",
    signup: "アカウント作成",
    toast: "実績を解除しました",
    names: {
      "videos-1": ["はじめての動画", "最初の動画を見る"],
      "videos-10": ["ウォーミングアップ", "動画を10本見る"],
      "videos-100": ["常連", "動画を100本見る"],
      "videos-1000": ["通", "動画を1,000本見る"],
      "hours-1": ["1時間", "合計1時間視聴する"],
      "hours-10": ["10時間", "合計10時間視聴する"],
      "hours-100": ["マラソン", "合計100時間視聴する"],
      "streak-3": ["3日連続", "3日連続で視聴する"],
      "streak-7": ["1週間連続", "1週間毎日視聴する"],
      "streak-30": ["1か月連続", "30日間毎日視聴する"],
      "follows-5": ["ファン", "スターやスタジオを5人フォローする"],
      "likes-25": ["大きなハート", "動画を25本いいねする"],
      "saves-10": ["コレクター", "動画を10本保存する"],
      "days-7": ["コインの1週間", "7日間コインを受け取る"],
      "days-30": ["コインの1か月", "30日間コインを受け取る"],
      "invites-1": ["友達を誘う", "登録してくれる友達を招待する"],
      "comments-1": ["はじめての一言", "最初のコメントを書く"],
      "comments-25": ["おしゃべり", "コメントを25件書く"],
      "votes-1": ["投票者", "今月のスターに投票する"],
    },
  },
  pwa: {
    appName: "Sweetアプリ",
    bannerLabel: "アプリをインストール",
    bannerPitch: "全画面、アプリストア不要",
    install: "インストール",
    notNow: "今はしない",
    installApp: "アプリをインストール",
    howToInstall: "インストール方法",
    inApp: "アプリで利用中です。",
    cardPitch: "ホーム画面からワンタップで全画面表示。アプリストアは不要です。",
    manual: "ブラウザのメニューを開き、{install}または{add}を選びます。",
    iosTitle: "Sweetをホーム画面に追加",
    iosShare: "ブラウザのバーで{share}をタップ（iOS 26では{more}、次に{share}）",
    iosAdd: "{add}を選ぶ",
    iosConfirm: "{confirm}をタップ：ホーム画面からSweetが全画面で開きます",
    share: "共有",
    more: "•••",
    add: "ホーム画面に追加",
    confirm: "追加",
    installMenu: "アプリをインストール",
    gotIt: "OK",
    close: "閉じる",
    offlineTitle: "オフラインです",
    offlineBody: "動画やライブカメラにはインターネット接続が必要です。接続を確認して、もう一度お試しください。",
    retry: "再試行",
    recent: "最近開いたページ",
  },
  notifications: {
    title: "お知らせ",
    empty: "まだ新着はありません。スターやスタジオをフォローしたり、ライブチャットのモデルをお気に入りに追加すると、ここに新着が届きます。",
    newVideos: "新着動画",
    liveNow: "配信中",
    markRead: "すべて既読にする",
    pushOn: "通知をオンにする",
    pushOff: "通知をオフにする",
    pushHint: "Sweetを閉じていても、新着動画やお気に入りの配信開始をお知らせします。",
    pushBlocked: "ブラウザの設定でSweetの通知がブロックされています。",
    pushUnsupported: "このブラウザは通知を表示できません。iPhoneでは、まずSweetをホーム画面に追加してください。",
    pushEnabled: "通知はオンです",
    favorites: "お気に入りモデル",
    addFavorite: "お気に入りに追加",
    removeFavorite: "お気に入りから削除",
    favoritesEmpty: "お気に入りのモデルはまだいません。ライブのハートをタップして追加しましょう。",
    offline: "オフライン",
    viewAll: "すべて見る",
  },
  forYou: {
    title: "おすすめ",
    all: "すべて",
    continueWatching: "続きを見る",
    intro: "いいね・保存・視聴・フォローから選んでいます。",
    empty: "動画やスターをいいね・保存・フォローすると、ここにおすすめの動画が表示されます。",
    more: "もっと見る",
  },
  shorts: {
    straight: "ストレート",
    gay: "ゲイ",
    trans: "ニューハーフ",
    watchFull: "フル動画を見る",
    like: "いいね",
    liked: "いいね済み",
    save: "保存",
    saved: "保存済み",
    share: "共有",
    copied: "リンクをコピーしました",
    soundOn: "音声をオン",
    soundOff: "音声をオフ",
    tapForSound: "タップで音声オン",
    report: "報告",
    follow: "フォロー",
    following: "フォロー中",
    previous: "前へ",
    next: "次へ",
    close: "閉じる",
    end: "今はここまでです。続きは動画ページで。",
    empty: "まだショートはありません。",
    live: "ライブ",
    watchLive: "無料でライブを見る",
    watching: "{n}人が視聴中",
    profile: "プロフィール",
    moreLive: "他のライブチャット",
  },
  search: {
    searches: "検索ワード",
    popular: "人気の検索ワード",
    categories: "カテゴリー",
    searchFor: "「{q}」で動画を検索",
    nothingFor: "「{q}」に一致する結果は見つかりませんでした。",
    title: "Sweet内を検索",
    placeholder: "動画・出演者・ブランドを検索",
    hint: "動画、ポルノスター、スタジオ、カテゴリーを検索できます。どのページでも / キーを押すと入力を始められます。",
    stars: "ポルノスター",
    productions: "スタジオ",
    other: "その他",
    otherProfiles: "その他のプロフィール",
    nothing: "見つかりませんでした",
    tryAgain: "キーワードを確認するか、より一般的な言葉で検索してみてください。",
    backHome: "ホームに戻る",
  },
  notFound: { title: "ページが見つかりません", body: "動画が削除されたか、URLが間違っている可能性があります。", home: "ホームへ" },
  common: {
    close: "閉じる",
    copy: "コピー",
    copied: "コピーしました",
    more: "その他",
    loading: "読み込み中",
    clearAll: "すべて消去",
    browseVideos: "動画を見る",
    scrollLeft: "左へスクロール",
    scrollRight: "右へスクロール",
  },
  actions: {
    react: "いいね",
    reacted: "いいね済み",
    save: "保存",
    saved: "保存済み",
    follow: "フォロー",
    following: "フォロー中",
    followName: "{name}をフォロー",
    unfollowName: "{name}のフォローを解除",
    moreOptions: "その他のオプション",
    share: "共有",
    copyLink: "リンクをコピー",
    linkCopied: "リンクをコピーしました",
    report: "報告",
    home: "Sweet — ホーム",
    onSweet: "Sweetの{name}",
    joinMe: "Sweetで一緒に楽しもう",
    inviteLink: "あなたの招待リンク",
  },
  library: {
    savedEmpty: "保存した動画はまだありません",
    savedHint: "動画の下のブックマークをタップすると、ここに保存されます。リストはこの端末にのみ保存されます。",
    reactedEmpty: "リアクションはまだありません",
    reactedHint: "ハートを付けた動画が新しい順にここに表示されます。",
    watchingEmpty: "視聴した動画はまだありません",
    watchingHint: "再生した動画は止めた位置と一緒にここに表示され、もう一度開くとその位置から再開します。",
    removeWatching: "視聴履歴から削除",
    removeVideo: "{title}を視聴履歴から削除",
    followingEmpty: "まだ誰もフォローしていません",
    followingHint: "クリエイターやスタジオの＋をタップすると、最新の動画がここに集まります。フォローはこの端末にのみ保存されます。",
    discoverModels: "モデルを探す",
    noVideosHint: "別のカテゴリをお試しください。新しい動画は毎日追加されます。",
    backToAll: "すべての動画に戻る",
  },
  player: {
    resumesAt: "{at}から再開",
    startOver: "最初から再生",
    unavailable: "この動画は現在ご利用いただけません。",
    play: "再生",
    pause: "一時停止",
    seek: "シーク",
    back10: "10秒戻る",
    forward10: "10秒進む",
    mute: "ミュート",
    unmute: "ミュート解除",
    volume: "音量",
    settings: "設定",
    pip: "ピクチャー・イン・ピクチャー",
    fullscreen: "全画面表示",
    exitFullscreen: "全画面表示を終了",
    quality: "画質",
    speed: "再生速度",
    normal: "標準",
    auto: "自動",
    partner: "提携サイト",
  },
  ads: { ad: "広告", advertisement: "広告", muteAd: "広告をミュート", unmuteAd: "広告のミュートを解除", skipIn: "{n}秒後にスキップ", skipAd: "広告をスキップ ›" },
  auth: {
    username: "ユーザー名",
    usernameOrEmail: "ユーザー名またはメールアドレス",
    emailOptional: "メールアドレス（任意）",
    password: "パスワード",
    currentPassword: "現在のパスワード",
    newPassword: "新しいパスワード",
    confirmPassword: "パスワード（確認）",
    confirmNewPassword: "新しいパスワード（確認）",
    showPassword: "パスワードを表示",
    hidePassword: "パスワードを隠す",
    forgot: "パスワードをお忘れですか？",
    remember: "ログインしたままにする",
    logIn: "ログイン",
    createAccount: "アカウントを作成",
    usernameHelp: "半角英字・数字・ドット・アンダースコアで3〜24文字。ランキングに表示されます。",
    emailHelp: "パスワードの再設定にのみ使用します。あとからアカウントで追加することもできます。",
    passwordHelp: "8文字以上。",
    adult: "18歳以上です。",
    agree: "{terms}と{privacy}に同意します。",
    terms: "利用規約",
    privacy: "プライバシーポリシー",
    savePhrasesTitle: "復元フレーズを保存してください",
    savePhrasesBody: "メールアドレスなしで登録したため、パスワードを忘れたときはこのフレーズでアカウントに戻れます。",
    continue: "続ける",
    resetHow: "パスワードの再設定方法",
    byEmail: "メールでリンクを受け取る",
    byPhrase: "復元フレーズを使う",
    phraseIntro: "メールアドレスなしで作成したアカウントの場合：ユーザー名と、登録時に保存した復元フレーズのいずれか1つを入力してください。",
    phrase: "復元フレーズ",
    phrasePlaceholder: "単語 単語 単語 単語",
    phraseHelp: "1つのフレーズの4つの単語。各フレーズは1回だけ使えます。",
    saveNewPassword: "新しいパスワードを保存",
    sendLink: "再設定リンクを送信",
  },
  phrases: {
    warning: "今すぐ保存してください。二度と表示されません。パスワードを忘れても、ユーザー名とこのフレーズのいずれか1つで新しいパスワードを設定できます。各フレーズは1回だけ使えます。誰にも教えないでください。",
    list: "あなたの復元フレーズ",
    copyAll: "すべてコピー",
    download: ".txtをダウンロード",
    savedCheck: "復元フレーズを安全な場所に保存しました。",
    done: "完了",
    fileTitle: "@{username} のSweet復元フレーズ",
    fileHow: "パスワードを忘れたら、{url} を開いて「{option}」を選び、ユーザー名とこのフレーズのいずれか1つを入力してください。",
    filePrivate: "各フレーズは1回だけ使えます。誰にも教えないでください。ユーザー名とこのフレーズのいずれかがあれば、誰でもあなたのアカウントを乗っ取れます。",
    none: "このアカウントにはメールアドレスも復元フレーズもありません。パスワードを忘れるとログインできなくなります。今すぐ復元フレーズを作成してください。",
    optional: "復元フレーズがあれば、メールなしで新しいパスワードを設定できます。アカウントにメールアドレスがある間は任意です。",
    left: "未使用のフレーズ：{total}個中{left}個。",
    leftMade: "未使用のフレーズ：{total}個中{left}個（{date}作成）。",
    how: "各フレーズはユーザー名と組み合わせて、1回だけ新しいパスワードを設定できます。なくしましたか？新しく作成すると、古いものは使えなくなります。",
    make: "復元フレーズを作成",
    makeNew: "新しいフレーズを作成",
  },
  account: {
    menu: "アカウントメニュー",
    settings: "アカウント設定",
    profiles: "あなたのプロフィール",
    logOut: "ログアウト",
    uploadPhoto: "写真をアップロード",
    removePhoto: "現在の写真を削除",
    displayName: "表示名",
    showInRankings: "ランキングに表示する",
    rankingsHelp: "あなたの名前・写真・視聴統計が公開の{link}に表示されます。オフにすると表示されなくなりますが、視聴時間は引き続き記録されます。",
    save: "保存",
    emailHelp: "パスワードを忘れたときにリンクを送るためだけに使います。空欄にすると削除されます。",
    saveEmail: "メールアドレスを保存",
    changePassword: "パスワードを変更",
    deleteWarning: "アカウント、保存した動画、リアクション、フォローが完全に削除されます。元に戻すことはできません。",
    typeToConfirm: "確認のため{word}と入力してください",
    deleteMine: "アカウントを削除",
  },
  pay: {
    billingPeriod: "お支払い期間",
    monthly: "月払い",
    yearly: "年払い",
    yourPlan: "ご利用中のプラン",
    month: "月",
    year: "年",
    oneMonth: "1か月",
    months: "{n}か月",
    oneYear: "1年",
    years: "{n}年",
    perMonth: "月あたり{price}",
    save: "{n}%お得",
    comingSoon: "近日公開",
    reward: "−{n}%（特典）",
    plays: "Sweet Room {n}回分",
    addedAtOnce: "すぐに付与",
    get: "{plan}にする",
    addMonth: "1か月追加",
    addYear: "1年追加",
    opensSoon: "お支払いはまもなく開始",
    alreadyMember: "すでにメンバーですか？",
    choose: "お支払い方法を選択",
    payWith: "お支払い方法",
    starsInBot: "Telegramボットで{n} Stars",
    card: "カード",
    crypto: "暗号資産",
    cryptoMore: "BTC、USDT、ETH、TONほか30種類以上",
    tooManyStars: "Telegram Starsの1回のお支払いには高額すぎます。",
    cardMin: "カード払いは{price}からです。",
    payStars: "Telegram Starsで支払う",
    preparing: "お支払いの準備中…",
    loginFirst: "まずログインしてください",
    cantStart: "お支払いを開始できません",
    noAdsCoins: "広告なし＋{n} Sweet Coins",
    addedOnPay: "お支払い後すぐに残高に追加されます",
    payInTelegram: "Telegramで支払う",
    waitingStars: "お支払いをお待ちしています。このページは自動で更新されます",
    allSet: "完了しました！",
    noAds: "広告は表示されません。",
    noAdsUntil: "{date}まで広告なし。",
    coinsAdded: "{n}コインが残高に追加されました。",
    startWatching: "視聴を始める",
    great: "OK",
    payCard: "カードで支払う",
    failedTitle: "お支払いが完了しませんでした",
    failedBody: "請求は発生していません。もう一度お試しください。",
    newTab: "新しいタブでお支払いください",
    newTabBody: "Chain2Payの安全なページで、カード・Apple Pay・Google Payが使えます。お支払いが済むと、このページは自動で更新されます。",
    waiting: "お支払いをお待ちしています…",
    openAgain: "お支払いページをもう一度開く",
    somethingWrong: "問題が発生しました。1分ほどしてからもう一度お試しください。",
    offline: "オフラインのようです。1分ほどしてからもう一度お試しください。",
    bestValue: "いちばんお得",
    coins: "コイン",
    orStars: "または{n} Stars",
    packsSoon: "コインパックはまもなく発売します。",
    nCoins: "{n} Sweet Coins",
    collected: "+{n} Sweet Coinsを受け取りました！",
    collectedToday: "本日分は受け取り済み",
    nextBonus: "次のボーナスまで",
    collecting: "受け取り中…",
    collect: "{n} Sweet Coinsを受け取る",
    alreadyCollected: "本日分のコインは受け取り済みです。また明日どうぞ。",
    offerLabel: "Sweet Coinsとプレミアム",
    offerTitle: "Sweet Coinsを手に入れよう",
    offerFor: "Sweet Roomと有料動画に",
    premiumFrom: "プレミアム {price}〜",
    upTo: "広告なし＋最大{n}コイン",
    packsFrom: "コインパック {price}〜",
    collectFree: "または毎日無料コインを受け取る",
    offerButton: "Sweet Coinsのオファー",
    guestCollected: "+{n} Sweet Coins！コインを失いたくない場合は、Sweetに登録してください。",
    guestKeep: "アカウントがない場合、コインは{days}日間だけ保管され、その後失効します。",
    guestSignup: "無料登録してコインを守る",
    guestLogin: "アカウントをお持ちの方はログイン",
    guestExpire: "{date}に{n}コインが失効します。",
    guestUnsaved: "コインはまだ保存されていません。登録して守りましょう",
    guestExpiring: "あなたのSweet Coinsのうち{n}枚が1日以内に失効します。無料登録してコインを守りましょう。",
  },
  footer: {
    copyright: "著作権",
    takedown: "削除申請",
    contact: "お問い合わせ",
    creators: "クリエイター向け",
    claim: "プロフィールの認証",
    webmasters: "ウェブマスター向け",
    terms: "利用規約",
    privacy: "プライバシー",
    info: "サイト情報",
    telegram: "Telegramの{site}",
  },
  report: {
    heading: "動画を報告",
    reason: "理由",
    takedown: "著作権 / DMCA",
    abuse: "同意なくこの動画に映っています",
    minor: "この動画に18歳未満の人物が含まれている可能性があります",
    other: "その他",
    url: "動画のリンクまたはID",
    email: "メールアドレス",
    details: "詳細",
    detailsPlaceholder: "削除してほしい内容とその理由を教えてください",
    send: "報告を送信",
  },
};
